<template>

  <div class="d-inline-block  center  ">

    <div class="dropdown " v-if="item.children.length !== 0">

      <a class="dropbtn  ">
        <b-icon icon="chevron-down" font-scale="1" class="ml-1"></b-icon>
        خدمات
      </a>

      <div class="dropdown-content">


        <b-nav-item class="px-3" :href="child.url" v-for="child in item.children" :key="child.id">
          {{ child.name }}
          <m-icon class="m-0" :icon="child.icon_class"/>
        </b-nav-item>

      </div>
    </div>
    <div class="dropdown" v-else>
      <a :href="item.url" class="btnnodrop ml-4">

        {{ item.name }}

        <m-icon class="m-0" :icon="item.icon_class"/>

      </a>

    </div>

  </div>

</template>

<script>

export default {
  name: "NavMenuItem",
  props: ['item'],
}
</script>

<style>

</style>

<style scoped>
.dropbtn {
  color: var(--dark);
  padding: 19px;
  font-size: 12px;
  border: none;
  text-decoration: none;
  cursor: pointer;
  font-weight: bold;
}


.btnnodrop {
  color: var(--dark);
  font-size: 12px;
  border: none;
  text-decoration: none;
  cursor: pointer;
  font-weight: bold;

}

.dropdown-content li {
  list-style: none;
}

.dropdown {
  z-index: 100;
  position: relative;
  display: inline-block;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #ffffff;
  min-width: 160px;
  border: 1px solid #eee;
  padding-bottom: 20px;
  margin-top: 16px;
  z-index: -45;

}

.dropdown-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
  border-bottom: 1px solid #eee;
  font-size: 12px;
  color: var(--dark);
  list-style: none;


}

.dropdown-content a:hover {
  color: #00b3d1;
  border-bottom: 1px solid #00b3d1;
}

.dropdown:hover .dropdown-content {
  display: block;
}

.dropdown:hover .dropbtn {
  background-color: white;
  border-top: 1px solid #eee;
  border-left: 1px solid #eee;
  border-right: 1px solid #eee;
  border-bottom: none;
  z-index: -50;

}

.center {
  padding: 35px 0;

}
</style>